module.exports = __webpack_public_path__ + "img/Superasy-SoloLogo.ef41d179.webp";